export { default } from './Metadades';
